"use strict";
/**
 * Admin API types for client-scoped storefront tags.
 * Tags are scoped to a client (not a channel) — PAID and OWNED storefronts share one tag pool.
 */
Object.defineProperty(exports, "__esModule", { value: true });
